import {Pipe, PipeTransform} from '@angular/core';


@Pipe({
  name: 'revisiones',
})
export class RevisionesPipe implements PipeTransform {

  transform(items: any[], filter: any[]) {

    if (filter['pendientes']) {
      console.log('entra aqui');
      items = items.filter(function (item) {
        return item.revisado == false;
      });
    }

    if (filter['id_estado'] != 0) {
      items = items.filter((item) => item.id_estado == 1 || item.id_estado == 4);
    }

    if ((filter['id_partida'] || filter['id_partida'] == 0) && filter['id_partida'] !== '') {
      items = items.filter(function (item) {
        return item.id_partida == filter['id_partida'];
      });
    }

    if (filter['id_produccion'] && filter['id_produccion'] > 0) {
      items = items.filter(function (item) {
        return item.id_produccion == filter['id_produccion'];
      });
    }

    return items;
  }
}



// WEBPACK FOOTER //
// ./src/pipes/revisiones/revisiones.ts